<template>
  <div class="john-deerling slide">
    <HorizontalAnimation :animation="animation" :loop=false />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">STORE 0111</p>
      <h1>BOLO Match</h1>
      <p>After obtaining Deerling’s photo ID from the DMV, API matches the suspect to two active BOLOs within the district.</p>
    </div>
    <router-link to="/trivia-4">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import Bolo from '@/assets/bolo.js'

export default {
  name: 'bolo',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: Bolo
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-layout {
    margin-top: 40px;
  }
</style>
